import { post, patch, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR, { mutate } from 'swr'
import { handleApiResponse } from './api_util';

async function getFlags() {

  const payload = {
    apiName: 'LivisiblyFlagApi',
    path: 'flags'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetFlags(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'FLAGS' : null,
    (path) => getFlags()
  );
  return result;
}

export function refetchCaseFlags() {
  mutate('FLAGS');
}



